import { MerchantDetails } from '@repo/api/endpoints/merchant';

import { getPlatformUrl } from '@/components/loan-form/helpers/get-platform-url';
import { getSettingsUrl } from '@/components/loan-form/helpers/get-settings-url';

export const completeDataLink = (merchantDetails?: MerchantDetails) => {
  if (!merchantDetails) return undefined;
  const platformUrl = getPlatformUrl();

  return getSettingsUrl(merchantDetails, platformUrl);
};
